import { PropsWithChildren } from 'react';
import styles from './Page.module.scss';

export interface PageProps {
  id?: string;
}

/* Page */
export default function Page({ children, id }: PropsWithChildren<PageProps>) {
  return (
    <div className={styles.pageContent} id={id}>
      {children}
    </div>
  );
}
/* */
